module.exports = __webpack_public_path__ + "img/onboarding-step1.2a2c3729de83a7efe9a9.4dc5053c.png";